<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div ref="chartContainer" style="width: 100%; height: 400px;" />
      </el-card>
    </template>
  </BasicLayout>

</template>

<script>
import echarts from 'echarts'
import { dateStrTodate } from '@/utils'

export default {
  name: 'BotSpinStat',
  props: {
    chartTitle: {
      type: String,
      default: '转动次数'
    },
    k: {
      type: String,
      default: 'spin'
    },
    c: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      chart: {},
      option: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: ''
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: [],
          axisLabel: {
            rotate: 45 // 标签旋转45度
          }
        },
        legend: {
          data: [],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: [{
          name: '总计',
          type: 'value',
          axisLabel: {
            formatter: '{value}' + this.c // 使用默认的数值格式
          }
        }],
        toolbox: {
          show: true,
          feature: {
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: []
      }
    },
    refresh(data) {
      const date = {}
      const userData = {}
      console.log('key', this.k)

      for (const i in data) {
        var val = data[i]
        date[val.date] = val.date
        if (userData[val.uid] === undefined) {
          userData[val.uid] = []
        }

        userData[val.uid].push(val[this.k])
      }

      for (const i in userData) {
        this.option.legend.data.push(i)
        const val = userData[i]
        const temp = {
          name: i,
          data: val,
          type: 'line',
          smooth: true,
          label: {
            // show: true,
            position: 'top', // 标签显示在折线图顶部
            formatter: '{c}' // 显示数值
          }
        }
        this.option.series.push(temp)
      }

      for (const i in date) {
        this.option.xAxis.data.push(dateStrTodate(date[i]))
      }

      this.option.title.text = this.chartTitle
      this.chart.setOption(this.option, true)
    }
  }

}
</script>

<style scoped>

</style>
